// extracted by mini-css-extract-plugin
module.exports = {"root":"Service_root__PP9VV","icon":"Service_icon__vjEU9","content":"Service_content__kjpcM","title":"Service_title__DmuE2","description":"Service_description__odULa"};